
import React from 'react';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { TrendingUp, Shield, LineChart, Users } from 'lucide-react';

const services = [
  {
    title: "Investissement",
    description: "Stratégies d'investissement personnalisées adaptées à vos objectifs financiers et à votre tolérance au risque.",
    icon: <TrendingUp className="h-10 w-10 text-patrimoine-gold" />
  },
  {
    title: "Protection patrimoniale",
    description: "Solutions pour protéger et préserver votre patrimoine face aux aléas de la vie et optimiser sa transmission.",
    icon: <Shield className="h-10 w-10 text-patrimoine-gold" />
  },
  {
    title: "Fiscalité",
    description: "Optimisation fiscale légale pour réduire votre imposition tout en respectant strictement la législation en vigueur.",
    icon: <LineChart className="h-10 w-10 text-patrimoine-gold" />
  },
  {
    title: "Transmission",
    description: "Planification successorale pour transmettre votre patrimoine à vos proches dans les meilleures conditions.",
    icon: <Users className="h-10 w-10 text-patrimoine-gold" />
  }
];

const ServicesSection = () => {
  return (
    <section id="services-section" className="bg-gradient-to-b from-white to-gray-50 py-24 px-6">
      <div className="container mx-auto">
        <div className="text-center mb-16">
          <h2 className="section-title mb-4">Nos Services</h2>
          <p className="text-patrimoine-muted max-w-2xl mx-auto text-lg">
            Découvrez notre gamme complète de services financiers conçus pour optimiser et sécuriser votre patrimoine
          </p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <Card 
              key={index} 
              className="border-t-4 border-t-patrimoine-gold hover:shadow-xl transition-all duration-300 group bg-white"
            >
              <CardHeader className="pb-2">
                <div className="mb-6 transform group-hover:scale-110 transition-transform duration-300">
                  {service.icon}
                </div>
                <h3 className="text-2xl font-serif text-patrimoine-dark">{service.title}</h3>
              </CardHeader>
              <CardContent>
                <p className="text-patrimoine-muted leading-relaxed">{service.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default React.memo(ServicesSection);
